import React from 'react';
import ErrorPage from '<src>/pages/ErrorPage';

export default () => <ErrorPage content={<h4>Page not found</h4>} />;
